import { render, staticRenderFns } from "./record-audio.vue?vue&type=template&id=77d8f471&scoped=true"
import script from "./record-audio.vue?vue&type=script&lang=js"
export * from "./record-audio.vue?vue&type=script&lang=js"
import style0 from "./record-audio.vue?vue&type=style&index=0&id=77d8f471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8f471",
  null
  
)

export default component.exports